import { useState } from 'react';
import { CncEquipment } from '../../../../shared/types/mtlinkiTypes.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { CncCoordinatesDialog } from './cncCoordinatesDialog.tsx';
import { CncCoordinatesTable } from './cncCoordinatesTable.tsx';

interface DialogState {
    equipment: CncEquipment,
}


export function CncCoordinates() {
    const [dialogState, setDialogState] = useState<DialogState | null>(null);


    const equipmentsQuery = trpc.equipments.getAllCncExt.useQuery(undefined, {
        select: (cncEquipments) => [...cncEquipments].sort((a, b) => a.displayName.localeCompare(b.displayName))
    });
    const equipments = equipmentsQuery.data;


    return (<>
        <div>
            <h2>Equipment coordinates</h2>
            {equipmentsQuery.isLoading && <div>Loading...</div>}
            {equipmentsQuery.error && <div>Error retrieving data</div>}
            {equipments && <CncCoordinatesTable
                style={{ width: '800px' }}
                equipments={equipments}
                onEditClick={(equipment) => setDialogState({ equipment })}
            />}
        </div>

        {dialogState && <CncCoordinatesDialog
            equipment={dialogState.equipment}
            onEquipmentUpdated={() => equipmentsQuery.refetch()}
            onClose={() => { setDialogState(null) }}
        />}
    </>)
}
